import { Component, EventEmitter, Output, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormsModule,
  ReactiveFormsModule,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { ButtonModule } from 'primeng/button';
import countriesData from '../../../../../countries.json';
import { Organization } from '../../../model/organization/organization.model';
import { Region } from '../../../model/region/region.model';
import { InputComponent } from '../../../shared/input/input.component';
import { InputSelectComponent } from '../../../shared/input-select/input-select.component';

@Component({
  selector: 'app-organization-form-modal',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DialogModule,
    InputComponent,
    DropdownModule,
    ButtonModule,
    InputSelectComponent
  ],
  templateUrl: './organization-form-modal.component.html',
  styleUrls: ['./organization-form-modal.component.scss']
})
export class OrganizationFormModalComponent {
  @Input() regionList: Region[] = [];
  @Output() save: EventEmitter<Organization> = new EventEmitter<Organization>();

  visible = false;
  isNewOrganization = true;
  organizationForm: FormGroup;
  localeOptions = [{ label: 'EN', value: 'en' }];
  countryOptions = countriesData.map(country => ({
    label: country.name,
    value: country.code
  }));

  constructor(private fb: FormBuilder) {
    this.organizationForm = this.fb.group({
      id: [null],
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      country: ['', Validators.required],
      locale: ['', Validators.required],
      regionId: ['', Validators.required]
    });
  }

  show(organization?: Organization) {
    if (organization) {
      this.isNewOrganization = false;
      this.organizationForm.setValue({
        id: organization.id || null,
        name: organization.name || '',
        email: organization.email || '',
        country: organization.country || '',
        locale: organization.locale || '',
        regionId: organization.regionId || ''
      });
    } else {
      this.isNewOrganization = true;
      this.organizationForm.reset({
        id: null,
        name: '',
        email: '',
        country: '',
        locale: '',
        regionId: ''
      });
    }
    this.visible = true;
  }

  hide() {
    this.visible = false;
  }

  onSubmit() {
    this.organizationForm.markAllAsTouched();

    if (this.organizationForm.valid) {
      this.save.emit(this.organizationForm.value);
      this.hide();
    }
  }

  onCancel() {
    this.hide();
  }

  getOrganizationDialogHeader(): string {
    return this.isNewOrganization
      ? $localize`:@@createOrganizationHeader:Create Organization`
      : $localize`:@@editOrganizationHeader:Edit Organization`;
  }
}
